import { theme } from "../../styles";
import PropTypes from "prop-types";

import { Box, Drawer, Slide } from "@mui/material";

const ResponsiveDrawer = ({
  children,
  onToggle,
  anchor = "right",
  drawerWidth = 256,
  mobileOpen = false,
}) => {
  return (
    <Box
      component="nav"
      sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
    >
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Drawer
        anchor={anchor}
        variant="temporary"
        open={mobileOpen}
        onClose={onToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            backgroundColor: `${theme.palette.secondary.main}`,
          },
        }}
      >
        <Slide in={mobileOpen} direction="left" mountOnEnter unmountOnExit>
          <Box>{children}</Box>
        </Slide>
      </Drawer>
      <Drawer
        anchor={anchor}
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            backgroundColor: `${theme.palette.secondary.main}`,
          },
        }}
        open
      >
        {children}
      </Drawer>
    </Box>
  );
};

ResponsiveDrawer.propTypes = {
  children: PropTypes.node,
  onToggle: PropTypes.func.isRequired,
};

export default ResponsiveDrawer;
